import { type CardPayload } from '@ankor-io/common/types/cards'
import { Loading, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@ankor-io/ui-components'

import { useConnectedAccountCardsQuery } from '@/queries'

export function ConnectedAccountCardsTable({
  connectedAccountId,
  orgId,
  vesselId,
}: {
  connectedAccountId: string
  orgId: string
  vesselId: string
}) {
  const { data: connectedAccountCards, isPending } = useConnectedAccountCardsQuery(orgId, vesselId, connectedAccountId)

  const getCardHolderDisplayName = (card: CardPayload) => {
    return [card.cardholder.firstName, card.cardholder.lastName].filter(Boolean).join(' ')
  }

  return (
    <div className="overflow-x-auto mt-8">
      <Table className="max-w-[calc(100vw-2rem)] lg:max-w-[calc(100vw-20rem)]">
        <TableHead>
          <TableRow>
            <TableHeader>Cardholder Name</TableHeader>
            <TableHeader>Last 4 digits</TableHeader>
            <TableHeader>Card Nickname</TableHeader>
            <TableHeader>Card Status</TableHeader>
            <TableHeader>Card ID</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {isPending ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className="text-center"
              >
                <div className="flex items-center justify-center">
                  <Loading />
                </div>
              </TableCell>
            </TableRow>
          ) : connectedAccountCards?.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className="text-center"
              >
                <div className="flex items-center justify-center">
                  <p>No cards found</p>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            connectedAccountCards?.map((card) => (
              <TableRow key={card.id}>
                <TableCell>
                  <span className="text-sm font-medium text-gray-900 dark:text-gray-50">
                    {getCardHolderDisplayName(card)}
                  </span>
                </TableCell>
                <TableCell>
                  <span className="text-sm text-gray-900 dark:text-gray-100">{card.maskedCardNumber}</span>
                </TableCell>
                <TableCell className="text-sm text-gray-900 dark:text-gray-100">{card.nickName}</TableCell>
                <TableCell className="text-sm text-gray-900 dark:text-gray-100">{card.status}</TableCell>
                <TableCell className="text-sm text-gray-900 dark:text-gray-100">{card.id}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  )
}
